<template>
    <form :id="id" @submit.prevent="handleSubmit" class="form-horizontal">
        <fieldset :disabled="disabled">
            <x-form-group
                label="Judul Chart"
                :error="getError('label')"
                :is-required="true"
                :horizontal="true"
            >
                <input
                    type="text"
                    class="form-control"
                    v-model="fields.label"
                    required
                />
            </x-form-group>

            <x-form-group
                :label="`Metrik (${fields.metrics.length})`"
                :error="getError('metrics')"
                :is-required="true"
                :horizontal="true"
            >
                <group-statistic-template-metric
                    v-for="(metric, index) in fields.metrics"
                    :key="metric.id"
                    :value="metric"
                    @input="(input) => updateMetric(index, input)"
                    @delete="deleteMetric(metric.id)"
                />
                <x-add-item-button @click="addMetric" />
            </x-form-group>
        </fieldset>
    </form>
</template>

<script>
import XAddItemButton from "../../components/XAddItemButton.vue";
import XAjaxDropdown from "../../components/XAjaxDropdown.vue";
import XCheckboxWrapper from "../../components/XCheckboxWrapper.vue";
import XDeleteItemButton from "../../components/XDeleteItemButton.vue";
import XFilterBox from "../../components/XFilterBox.vue";
import XFormGroup from "../../components/XFormGroup.vue";
import XHelpDefault from "../../components/XHelpDefault.vue";
import XTable from "../../components/XTable.vue";
import FormErrorMixin from "../../mixins/FormErrorMixin";
import PropertySyncMixin from "../../mixins/PropertySyncMixin";
import GroupStatisticTemplateMetric from "./GroupStatisticTemplateMetric.vue";

const defaultMetric = {
    id: null,
    label: "",
    status: null,
    group_excludes: [],
    group_includes: [],
    category_excludes: [],
    category_includes: [],
};

export default {
    components: {
        XFormGroup,
        XFilterBox,
        XCheckboxWrapper,
        XTable,
        XAddItemButton,
        XAjaxDropdown,
        XDeleteItemButton,
        GroupStatisticTemplateMetric,
        XHelpDefault,
    },
    created() {
        this.fields = {
            ...this.fields,
            ...this.initialFields,
        };
    },
    data() {
        return {
            fields: {
                label: null,
                metrics: [],
            },
        };
    },
    methods: {
        addMetric() {
            this.fields.metrics.push({
                ...defaultMetric,
                id: new Date().getTime(),
            });
        },
        deleteMetric(target) {
            this.fields.metrics = this.fields.metrics.filter(
                (metric) => metric.id !== target
            );
        },
        handleSubmit() {
            this.$emit("submit", { ...this.fields });
        },
        updateMetric(index, metric) {
            this.$set(this.fields.metrics, index, metric);
        },
    },
    mixins: [FormErrorMixin, PropertySyncMixin],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Object,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        initialFields: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
};
</script>
